<script lang="ts">
	import { v4 } from "uuid";
	export let checked = true;
	export let disabled = false;
	const id = v4();

</script>

<label for={id} on:click>
	<span class="switch">
		<input id={id} type="checkbox" on:change bind:checked disabled={disabled} />
		<span class="slider"> <span class="circle" /> </span>
	</span>
</label>

<style lang="scss">
	span {
		display: inline-block;

		&.switch {
			cursor: pointer;

			position: relative;
			width: 56.3px;
			height: 30px;

			input:checked + .slider:hover .circle::before {
				background-color: rgba($color: #6591fa, $alpha: 0.1);
			}

			input:checked + .slider .circle {
				transform: translateX(26px);
			}
			input:checked + .slider {
				background-color: #6591fa;
			}

			input:focus + .slider {
				box-shadow: 0 0 1px #6591fa;
			}
		}

		input {
			display: none;
			width: 0;
			height: 0;
		}

		&.slider {
			position: absolute;
			width: 100%;
			height: 100%;
			border-radius: 30px;
			background-color: #bbbbbb;
			transition: 0.2s;
		}

		&.slider .circle {
			position: absolute;
			left: 2px;
			bottom: 2px;

			width: 26px;
			height: 26px;
			background-color: white;

			transition: 0.2s;
			border-radius: 18px;
		}

		.slider:hover .circle:before {
			content: "";
			position: absolute;
			left: 50%;
			top: 50%;

			width: 30px;
			height: 30px;
			background-color: rgba($color: #bbbbbb, $alpha: 0.1);
			transform: translate(-50%, -50%);
			transition: 0.2s;
			border-radius: 18px;
		}
	}

</style>
